<template>
    <div ref="container" />
</template>

<script lang="ts">
import Vue from "vue";
// Importado para ativar o augmentation de $route e $router no arquivo
import "vue-router";
import Bus from "@/utils/events/bus";

// Interface local — não importa tipos de src/react/ para evitar conflito
// com o namespace JSX global do Vue (shims-tsx.d.ts).
interface ReactHandle {
    unmount(): void;
    render(page: "lista" | "edicao", id?: number, onNavigate?: (path: string) => void): void;
}

export default Vue.extend({
    name: "ReactMountLaboratorio",

    data(): { handle: ReactHandle | null; alive: boolean } {
        return { handle: null, alive: false };
    },

    computed: {
        page(): "lista" | "edicao" {
            return this.$route.name === "laboratorio-lista" ? "lista" : "edicao";
        },
        routeId(): number | undefined {
            const raw = this.$route.params.id;
            return raw ? parseInt(raw, 10) : undefined;
        },
    },

    async mounted() {
        this.alive = true;
        Bus.$emit("hide-nav-menu", true);
        // @ts-ignore — src/react/ é compilado pelo Babel; os tipos não estão
        // no tsconfig do Vue de propósito para evitar conflitos com JSX global.
        const { mountLaboratorioApp } = await import(/* webpackChunkName: "react-apps" */ "@/react/mount");
        if (!this.alive) {
            return;
        }
        const container = this.$refs.container as HTMLElement | null;
        if (!container) {
            return;
        }
        this.handle = (mountLaboratorioApp as (el: HTMLElement) => ReactHandle)(container);
        this.rerender();
    },

    watch: {
        $route(): void {
            Bus.$emit("hide-nav-menu", true);
            this.rerender();
        },
    },

    beforeDestroy() {
        this.alive = false;
        this.handle?.unmount();
        this.handle = null;
    },

    methods: {
        rerender() {
            this.handle?.render(
                this.page,
                this.routeId,
                (path: string) => { this.$router.push(path); },
            );
        },
    },
});
</script>
